import React from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Button,
  Form,
  Input,
  FormFeedback,
  ButtonGroup,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useSelector, useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { editConstruction, updateConstruction } from "../../../store/actions"

import { useEffect, useState } from "react"

const EditConstruction = props => {
  const dispatch = useDispatch()
  document.title = "Edit Construction"
  const { id } = useParams()

  const [details, setDetails] = useState({})

  useEffect(() => {
    dispatch(editConstruction(id))
  }, [dispatch])

  const constructs = useSelector(state => state.construction)

  useEffect(() => {
    let construc = []
    if (constructs && constructs.construction && constructs.construction.length > 0) {
      construc = constructs.construction.filter(
        construction => construction.construction_id == id
      )
    }
    if (construc.length > 0) {
      setDetails(construc[0])
    } else {
      props.history.push("/dropdown/construction/list")
    }
  }, [])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      construction_id: details && details.construction_id ? details.construction_id : "",

      construction:
        details && details.construction ? details.construction : "",

      is_default: details && details.is_default ? 1 : 0,
    },
    validationSchema: Yup.object({
      construction: Yup.string().required("Please enter construction"),
    }),
    onSubmit: values => {
      values.construction_id = id // construction_id is from api thats why this needs to be same with "id"
      dispatch(updateConstruction(values, props.history))
    },
  })

  const { error } = useSelector(state => ({
    error: state.construction.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Edit Construction" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="editCnstForm"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3 mt-1">
                          <Label htmlFor="const">Construction</Label>
                          <Input
                            name="construction"
                            type="text"
                            id="const"
                            autoComplete="off"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.construction || ""}
                          />
                          {validation.touched.construction &&
                          validation.errors.construction ? (
                            <FormFeedback type="invalid">
                              {validation.errors.construction}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      <h6>Default : </h6>
                      <ButtonGroup>
                        <Button
                          name="is_default"
                          color="success"
                          outline
                          value={1}
                          active={validation.values.is_default == 1}
                          onClick={validation.handleChange}
                        >
                          Yes
                        </Button>

                        <Button
                          name="is_default"
                          color="secondary"
                          outline
                          value={0}
                          active={validation.values.is_default == 0}
                          onClick={validation.handleChange}
                        >
                          No
                        </Button>
                      </ButtonGroup>
                    </div>
                    <br />
                    <div>
                      {constructs && constructs.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Updating ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Update
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default EditConstruction
